import React from 'react'
import { Pane, Text, majorScale } from 'evergreen-ui'

const InitialState = () => (
  <Pane textAlign="center" padding={majorScale(5)}>
    <Text>Start typing to search your workspace</Text>
  </Pane>
)

export default InitialState
